import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import { BG_COLORS, FONT_COLORS } from "../../constants";
import Slider, { Settings } from "react-slick";
import testimonial1 from "../../assets/testimonials/1.svg";
import testimonial2 from "../../assets/testimonials/2.svg";
import testimonial3 from "../../assets/testimonials/3.svg";
import testimonial4 from "../../assets/testimonials/4.svg";
import testimonial5 from "../../assets/testimonials/5.svg";
import testimonial6 from "../../assets/testimonials/6.svg";
import { Box, Stack, Typography, useTheme, styled } from "@mui/material";
import Logo from "../Logo";

export const AuthSlider = () => {
  const theme = useTheme();

  const settings: Settings = {
    centerMode: true,
    dots: false,
    infinite: true,
    autoplay: true,
    arrows: false,
    speed: 500,
    variableWidth: true,
    slidesToShow: 1,
    adaptiveHeight: true,
  };

  return (
    <Stack
      height="100%"
      flexDirection="column"
      justifyContent="space-between"
      sx={{
        backgroundColor: BG_COLORS.primary,
        [theme.breakpoints.down("md")]: {
          minHeight: "auto",
          pb: 6,
        },
      }}
    >
      <Box
        maxWidth={170}
        mx={4}
        mt={4}
        sx={{
          [theme.breakpoints.down("md")]: {
            minHeight: "auto",
            pb: 10,
          },
        }}
      >
        <Logo variant="light" width="100%" />
      </Box>
      <Box>
        <Box px={4} mb={8}>
          <Typography
            fontSize={52}
            fontWeight={700}
            lineHeight={1.3}
            color={FONT_COLORS.white}
            width="70%"
            sx={{
              [theme.breakpoints.down("xl")]: {
                width: "100%",
              },
              [theme.breakpoints.down("lg")]: {
                fontSize: 40,
              },
              [theme.breakpoints.down("md")]: {
                fontSize: 52,
              },
              [theme.breakpoints.down("md")]: {
                fontSize: 40,
              },
            }}
          >
            Smarter sourcing starts here
          </Typography>
          <Typography
            mt={2}
            fontSize={16}
            fontWeight={500}
            lineHeight={1.8}
            color={FONT_COLORS.light}
            width="70%"
            sx={{
              [theme.breakpoints.down("xl")]: {
                width: "100%",
              },
              [theme.breakpoints.down("lg")]: {
                fontSize: 14,
              },
              [theme.breakpoints.down("md")]: {
                fontSize: 16,
              },
            }}
          >
            Analyze products fast, save hours of research, and scale your Amazon business with ease
          </Typography>
        </Box>
        <Slider {...settings}>
          <Box sx={{ mx: 2 }}>
            <img src={testimonial1} alt="Testimonial 1" />
          </Box>
          <Box sx={{ mx: 2 }}>
            <img src={testimonial2} alt="Testimonial 2" />
          </Box>
          <Box sx={{ mx: 2 }}>
            <img src={testimonial3} alt="Testimonial 3" />
          </Box>
          <Box sx={{ mx: 2 }}>
            <img src={testimonial4} alt="Testimonial 4" />
          </Box>
          <Box sx={{ mx: 2 }}>
            <img src={testimonial5} alt="Testimonial 5" />
          </Box>
          <Box sx={{ mx: 2 }}>
            <img src={testimonial6} alt="Testimonial 6" />
          </Box>
        </Slider>
      </Box>
      <Box height={20} />
    </Stack>
  );
};

export default AuthSlider;
